<template>
  <btn
    class="product-card__quick-add-button"
    :label="$string('collection.quick_add')"
    :aria-label="ariaLabel"
    :show-icon="false"
    modifiers="outlined"
    @click="openQuickAdd(activeProduct)"
  />

  <boost-analytics
    :analytics-event="analyticsEvent"
    type="filter"
  />
</template>

<script>

/**
 * Vue: Quick add button (quick-view-button)
 * -----------------------------------------------------------------------------
 * Button to open the quick add modal or quick add to cart on product cards.
 * @param {Object} activeProduct
 * @param {String} activeProduct.handle - Used to update quick add product.
 * @param {Number} activeProduct.id - Used for analytics for both button types.
 *
 */
import BoostAnalytics from '~global/boost-analytics/boost-analytics'
import Btn from '~global/btn/btn'

export default {
  name: 'QuickAddButton',

  components: {
    BoostAnalytics,
    Btn,
  },

  props: {
    activeProduct: {
      type: Object,
      default: () => ({
        handle: '',
        id: 0,
      }),
    },
    ariaLabel: {
      type: String,
      required: false,
    },
  },

  emits: {
    'quick-add-btn-click': (payload) => typeof payload === 'string',
  },

  data() {
    return {
      analyticsEvent: {},
    }
  },

  methods: {

    /**
     * Open the quick add modal for the active product.
     */
    openQuickAdd(activeProduct) {
      this.$emit('quick-add-btn-click', activeProduct.handle)
      this.handleAnalyticsEvent(activeProduct.id)
    },

    /**
     * Pass data from analytics events to analytics component.
     * @param {String} productId - Product ID to string.
     */
    handleAnalyticsEvent(productId) {
      this.analyticsEvent = {
        pid: productId,
        u: 'view_product',
      }
    },
  },
}
</script>
